module.exports = __webpack_public_path__ + "static/02-8acf6eb01d61b351ead17da07cb4e5fc.png";